/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wait_Until_Processing_CompleteInputs */



/**
* | output |
* | --- |
* | "Please wait until all files are finished processing before closing this window." |
*
* @param {Wait_Until_Processing_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const wait_until_processing_complete = /** @type {((inputs?: Wait_Until_Processing_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wait_Until_Processing_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez attendre que tous les fichiers soient traités avant de fermer cette fenêtre.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte warten Sie, bis alle Dateien vollständig verarbeitet sind, bevor Sie dieses Fenster schließen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attendi che l'elaborazione di tutti i file sia terminata prima di chiudere questa finestra.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, подождите, пока обработка всех файлов завершится, прежде чем закрывать это окно.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Espere hasta que todos los archivos terminen de procesarse antes de cerrar esta ventana.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请等待所有文件处理完毕后再关闭此窗口。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このウィンドウを閉じる前に、すべてのファイルの処理が完了するまでお待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया इस विंडो को बंद करने से पहले सभी फाइलों की प्रोसेसिंग पूरी होने तक प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aguarde até que todos os arquivos sejam processados completamente antes de fechar esta janela.")
	return /** @type {LocalizedString} */ ("Please wait until all files are finished processing before closing this window.")
});